export const lang = useLocalStorage('lang', 'fr')
